import { render, staticRenderFns } from "./veSbzcZcCategoryShow.vue?vue&type=template&id=cb6b69c4&scoped=true"
import script from "./veSbzcZcCategoryShow.vue?vue&type=script&lang=js"
export * from "./veSbzcZcCategoryShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6b69c4",
  null
  
)

export default component.exports